import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';
import {Observable} from 'rxjs';
import {Entity} from '../../entity';

@Component({
  selector: 'app-color-picker',
  styleUrls: ['color.scss'],
  template: `
    <mat-form-field *ngIf="field.name && field.inputType && group?.get(field.name)" [formGroup]="group" appearance="fill">
      <mat-label>{{ field.label | async | default: '' }}</mat-label>
      <input matInput [placeholder]="''" [formControlName]="field.name" (colorPickerChange)="changeColor($event)" (colorPickerSelect)="changeColor($event)" [(colorPicker)]="color" />
      <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group?.get(field.name)?.hasError(validation.name)">{{validation.message$ | async}}</mat-error>
      </ng-container>
      <ng-container ngProjectAs="mat-error">
        <mat-error
          *ngIf="group?.get(field.name)?.hasError('custom')">{{group?.get(field.name)?.getError('custom').message}}</mat-error>
      </ng-container>
    </mat-form-field>
  `,
})
export class ColorComponent implements OnInit, OnDestroy {
  field: FieldConfig;
  group: FormGroup;
  parentEntity$ = new Observable<Entity>();
  color: string;

  ngOnInit(): void {
    this.color = this.group.get(this.field.name).value;
  }

  // make sure to destory the editor
  ngOnDestroy(): void {
  }

  constructor() {
    this.group = new FormGroup({});
    this.field = new FieldConfig();
  }

  changeColor(color: string) {
    this.group.get(this.field.name).setValue(color);
  }
}
